module.exports = __webpack_public_path__ + "static/media/girls._taking_photo.a3851567.png";